import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { useCookieState } from './useCookieState'

/**
 * The mobile app uid. Prefers the `uid` query param and falls back to the `x-uid`
 * cookie, since pages like order tracking are opened without the param.
 */
export const useUserId = () => {
  const router = useRouter()
  const [cookieUid] = useCookieState<string>('x-uid', '')
  return useMemo(() => {
    return router.query.uid?.toString() || cookieUid
  }, [router.query.uid, cookieUid])
}
